export const xsmallDevice = "@media (max-width: 575.98px)";
export const smallDevice =
  "@media (min-width: 576px) and (max-width: 767.98px)";
export const mediumDevice =
  "@media (min-width: 768px) and (max-width: 991.98px)";
export const largeDevice =
  "@media (min-width: 992px) and (max-width: 1199.98px)";
export const xlargeDevice = "@media(min-width: 1200px)";
